export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40e93ebf14e0ba90e5d62bf118016a02ecf329cde5&name=revalidateCommunity!'